const SECRETS = {
  serverurl: 'https://caebes.com:8000',
  MAPSAPIKEY: 'AIzaSyCNb4lCUJsVnpFDf5jLbJd4SykZYzRMAZM',
};

export default SECRETS;